"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../../static/icons/icons");

var _palette = require("../../../../styles/palette");

var _helpers = require("../../../../helpers");

var _index = _interopRequireDefault(require("../../Icon/index"));

var _style = require("./style");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var accentFold = _helpers.helpers.accentFold;

var parseForInput = function parseForInput(value) {
  return accentFold(value.toLowerCase());
};

var InputSelect = function (_PureComponent) {
  (0, _inherits2["default"])(InputSelect, _PureComponent);

  var _super = _createSuper(InputSelect);

  function InputSelect() {
    var _temp, _this;

    (0, _classCallCheck2["default"])(this, InputSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2["default"])(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      focused: false,
      firstItemNumber: 0,
      selected: -1
    }, _this.handleChangeValue = function (option, callback) {
      var _this$props = _this.props,
          formatTitleOnSelect = _this$props.formatTitleOnSelect,
          handleChange = _this$props.handleChange,
          titleOptionProp = _this$props.titleOptionProp,
          valueOptionProp = _this$props.valueOptionProp;
      var selectedOption = _this.state.selectedOption;

      if (handleChange && option !== selectedOption) {
        handleChange(option[valueOptionProp]);
      }

      _this.setState({
        selected: -1,
        selectedOption: option,
        text: formatTitleOnSelect ? formatTitleOnSelect(option) : (option || {})[titleOptionProp] || '',
        focused: false
      }, callback);
    }, _this.handleNavigation = function (e) {
      var optionsToShow = _this.state.optionsToShow;

      if (e.target.value === '') {
        _this.setState({
          focused: true
        });
      }

      switch (e.which) {
        case 13:
          e.target.blur();
          break;

        case 38:
          _this.setState(function (prevState) {
            return {
              selected: prevState.selected >= 0 ? prevState.selected - 1 : optionsToShow.length - 1
            };
          });

          break;

        case 40:
          _this.setState(function (prevState) {
            return {
              selected: prevState.selected < optionsToShow.length - 1 ? prevState.selected + 1 : -1
            };
          });

          break;

        default:
          _this.setState({
            selected: -1
          });

          break;
      }
    }, _this.onChangeInput = function (e) {
      var _this$props2 = _this.props,
          filter = _this$props2.filter,
          options = _this$props2.options,
          titleOptionProp = _this$props2.titleOptionProp;

      if (e.target.value === '') {
        _this.setState({
          text: e.target.value,
          selectedOption: null,
          optionsToShow: options.slice(0, 25),
          options: options
        });
      } else {
        var filterOptions;

        if (filter) {
          filterOptions = options.filter(filter(e.target.value));
        } else {
          filterOptions = options.filter(function (o) {
            var title = parseForInput(o[titleOptionProp]);
            var value = parseForInput(e.target.value);
            return title.includes(value);
          });
        }

        _this.setState({
          text: e.target.value,
          optionsToShow: filterOptions.slice(0, 25),
          options: filterOptions
        });
      }
    }, _this.onFocus = function (e) {
      var _this$props3 = _this.props,
          options = _this$props3.options,
          filter = _this$props3.filter,
          titleOptionProp = _this$props3.titleOptionProp;

      if (e.target.value === '') {
        _this.setState({
          focused: true,
          optionsToShow: options.slice(0, 25),
          options: options
        });
      } else {
        var filterOptions;

        if (filter) {
          filterOptions = options.filter(filter(e.target.value));
        } else {
          filterOptions = options.filter(function (o) {
            var title = parseForInput(o[titleOptionProp]);
            var value = parseForInput(e.target.value);
            return title.includes(value);
          });
        }

        _this.setState({
          focused: true,
          optionsToShow: filterOptions.slice(0, 25),
          options: filterOptions
        });
      }
    }, _this.onBlur = function (e) {
      var options = _this.props.options;
      var _this$state = _this.state,
          optionsToShow = _this$state.optionsToShow,
          selected = _this$state.selected;

      if (selected >= 0 && optionsToShow[selected]) {
        _this.handleChangeValue(optionsToShow[selected]);

        return;
      }

      _this.setState({
        text: e.target.value,
        selectedOption: null,
        focused: false,
        optionsToShow: options.slice(0, 25),
        options: options
      });
    }, _this.onScrollOptions = function (element) {
      var itemHeight = _this.props.itemHeight;
      var whereIShouldStart = Math.floor(element.target.scrollTop / itemHeight) - 15 > 0 ? Math.floor(element.target.scrollTop / itemHeight) : 0;
      var whereIShouldFinish = Math.floor(Math.floor(element.target.scrollTop / itemHeight) + 15);

      _this.setState(function (prevState) {
        return {
          optionsToShow: prevState.options.slice(whereIShouldStart, whereIShouldFinish),
          firstItemNumber: whereIShouldStart,
          selected: -1
        };
      });
    }, _temp));
  }

  (0, _createClass2["default"])(InputSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          cancelText = _this$props4.cancelText,
          className = _this$props4.className,
          error = _this$props4.error,
          extraInfo = _this$props4.extraInfo,
          helper = _this$props4.helper,
          id = _this$props4.id,
          itemHeight = _this$props4.itemHeight,
          label = _this$props4.label,
          renderOption = _this$props4.renderOption,
          valueOptionProp = _this$props4.valueOptionProp;
      var _this$state2 = this.state,
          focused = _this$state2.focused,
          text = _this$state2.text,
          optionsToShow = _this$state2.optionsToShow,
          options = _this$state2.options,
          firstItemNumber = _this$state2.firstItemNumber,
          selected = _this$state2.selected;
      return _react["default"].createElement(_react["default"].Fragment, null, focused && _react["default"].createElement(_style.Background, null), focused && _react["default"].createElement(_style.Header, null, _react["default"].createElement(_index["default"], {
        color: _palette.palette.primary,
        icon: _icons.ICONS.BOB,
        size: 40
      }), _react["default"].createElement(_style.Separator, null), _react["default"].createElement(_style.Cancel, null, cancelText)), _react["default"].createElement(_style.Container, {
        focused: focused,
        className: className
      }, extraInfo && _react["default"].createElement(_style.Extra, null, extraInfo), _react["default"].createElement(_style.Label, {
        dirty: text !== '',
        active: focused
      }, label), _react["default"].createElement(_style.InputContainer, {
        focused: focused,
        error: error
      }, _react["default"].createElement("input", {
        onChange: this.onChangeInput,
        onKeyUp: this.handleNavigation,
        type: "text",
        id: id || '',
        value: text || '',
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        autoComplete: "off"
      }), _react["default"].createElement("span", null, helper)), _react["default"].createElement(_style.Options, {
        focused: focused,
        onScroll: this.onScrollOptions
      }, _react["default"].createElement(_style.ScrollContainer, {
        optionsLength: options.length,
        itemHeight: itemHeight
      }, optionsToShow.map(function (selection, i) {
        return renderOption ? renderOption(_objectSpread(_objectSpread({}, selection), {}, {
          key: selection[valueOptionProp],
          onMouseDown: function onMouseDown() {
            return _this2.handleChangeValue(selection);
          },
          selected: selected === i,
          topPosition: (firstItemNumber + i) * itemHeight
        })) : _react["default"].createElement(_style.Option, {
          key: selection.title,
          "data-value": selection.value,
          "data-key": "select-".concat(i),
          role: "link",
          tabIndex: "0",
          featured: selected !== i && selection.featured,
          selected: selected === i,
          onMouseDown: function onMouseDown() {
            return _this2.handleChangeValue(selection);
          },
          itemNumber: firstItemNumber + i
        }, _react["default"].createElement(_style.Ellipsis, null, selection.title));
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.focused) return state;
      var initValue = props.value ? props.options.find(function (opt) {
        return opt[props.valueOptionProp] === props.value;
      }) : null;
      var initText = initValue && props.formatTitleOnSelect && props.formatTitleOnSelect(initValue);
      return _objectSpread(_objectSpread({}, state), {}, {
        text: initText || (initValue && initValue[props.titleOptionProp] ? initValue[props.titleOptionProp] : ''),
        optionsToShow: props.options.slice(0, 25),
        options: props.options,
        selectedOption: initValue
      });
    }
  }]);
  return InputSelect;
}(_react.PureComponent);

InputSelect.propTypes = {
  cancelText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  extraInfo: _propTypes["default"].string,
  filter: _propTypes["default"].func,
  formatTitleOnSelect: _propTypes["default"].func,
  handleChange: _propTypes["default"].func,
  helper: _propTypes["default"].string,
  id: _propTypes["default"].string,
  itemHeight: _propTypes["default"].number,
  label: _propTypes["default"].string.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  renderOption: _propTypes["default"].func,
  titleOptionProp: _propTypes["default"].string,
  valueOptionProp: _propTypes["default"].string
};
InputSelect.defaultProps = {
  cancelText: 'Cancel',
  className: undefined,
  extraInfo: undefined,
  filter: undefined,
  formatTitleOnSelect: undefined,
  handleChange: function handleChange() {},
  id: undefined,
  itemHeight: 50,
  helper: undefined,
  error: undefined,
  renderOption: undefined,
  titleOptionProp: 'title',
  valueOptionProp: 'value'
};
var _default = InputSelect;
exports["default"] = _default;